import React from 'react'
import './css/AboutCard.css'

function AboutCard({icon, title, content}) {
  return (
    <div className='AboutCard'>
        <div className='head'>
            {icon}
            <h1>{title}</h1>
        </div>
        <p>{content}</p>
    </div>
  )
}

export default AboutCard